import React, { useState, useEffect } from "react";



import { useNavigate, Link, useParams } from "react-router-dom";
import db from "./Firebase";
import Footer from "./Footer";

function Certificates() {
    let params = useParams();
    const navigate = useNavigate();
    const [personalData, setPersonalData] = useState({});
    const [certificates, setCertificates] = useState([]); // ✅ Store certificates
    const [selectedImage, setSelectedImage] = useState(""); // ✅ Store selected certificate for preview
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        // ✅ Fetch user details from portfolio_details
        db.collection("portfolio_details")
            .where("username", "==", params.id.toLowerCase())
            .onSnapshot((snapshot) => {
                if (snapshot.docs.length === 0) {
                    navigate("/error");
                } else {
                    setPersonalData(snapshot.docs[0].data());
                    setIsLoading(false);
                }
            });
    }, []);

    useEffect(() => {
        if (personalData.phone_no) {
            // ✅ Fetch certificates based on user's phone number
            db.collection("nv_certificates")
                .where("phone_no", "==", personalData.phone_no)
                .onSnapshot((snapshot) => {
                    const certs = snapshot.docs.map((doc) => doc.data());
                    setCertificates(certs);
                    if (certs.length > 0) {
                        setSelectedImage(certs[0].certificate_image); // ✅ Set first certificate as default preview
                    }
                });
        }
    }, [personalData.phone_no]);

    return (
        <>
            <section style={{ boxShadow: "0 6px 6px -6px #777" }}>
                <div className="navi">
                    <input type="checkbox" id="nav-check" />
                    <div className="nav-header">
                        <div className="nav-title">
                            <Link to={`/${params.id.toLowerCase()}`}>
                                <img src="/images/youvati_logo.webp" alt="Youvati Logo" style={{ height: "27px", marginLeft: "2rem" }} />
                            </Link>
                        </div>
                    </div>
                </div>
            </section>

            {isLoading ? (
                <div>
                    <img src="images/loader.gif" alt="Loading..." style={{ display: "block", marginLeft: "auto", marginRight: "auto", width: "40%" }} />
                </div>
            ) : (
                <section className="section bg-default bg-gray-100 mb-5">
                    <div className="container-fluid">
                        <div className="container pt-5 certificateviewH">
                            <div className="row">
                                {/* ✅ Show certificate thumbnails */}
                                {certificates.map((cert, index) => (
                                    <div key={index} className="col">
                                        <div className="pb-2" style={{ height: "9rem", width: "9rem", marginBottom: "2rem" }}>
                                            <img
                                                src={cert.certificate_image}
                                                alt={cert.certificate_name}
                                                className="img-thumbnail"
                                                width="200"
                                                height="200"
                                                onClick={() => setSelectedImage(cert.certificate_image)} // ✅ Set image preview on click
                                                style={{ cursor: "pointer" }}
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-1"></div>
                            <div className="col-md-2 p-4 certificateviewV">
                                <ul>
                                    {/* ✅ Certificate Sidebar Preview */}
                                    {certificates.map((cert, index) => (
                                        <li key={index}>
                                            <img
                                                src={cert.certificate_image}
                                                onClick={() => setSelectedImage(cert.certificate_image)}
                                                alt={cert.certificate_name}
                                                className="img-thumbnail"
                                                width="204"
                                                height="136"
                                                style={{ cursor: "pointer" }}
                                            />
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            <div className="col-md-8 p-4">
                                {/* ✅ Large Image Preview */}
                                {selectedImage && (
                                    <img
                                        src={selectedImage}
                                        className="img-fluid"
                                        alt="Certificate Preview"
                                        width="780"
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </section>
            )}

            <Footer />
        </>
    );
}

export default Certificates;


// import React, { useState, useEffect } from "react";


// import { useNavigate, Link, useParams } from "react-router-dom"
// import db from "./Firebase";
// import axios from "axios";
// // import { firebase, auth } from './FirebaseLogin';
// import Footer from "./Footer";

// function Certificates() {
//     let params = useParams();
//     const navigate = useNavigate();
//     const [personalData, setPersonalData] = useState({});
//     useEffect(() => {
//         db.collection("portfolio_details").where('username', '==', params.id.toLowerCase()).onSnapshot((snapshot) => {
//             snapshot.docs.map(e => setPersonalData(e.data()))
//             if (snapshot.docs.length == 0) {
//                 navigate('/error');
//             } else {
//                 // alert("exists")
//                 setIsLoading(false);
//             }
//         });
//     }, []);
//     const [isLoading, setIsLoading] = useState(true)
//     const [img, setImg] = useState("")
//     // services_images

//     const selectedImage = (e) => {
//         console.log(e)
//         setImg(e)
//     }
//     return (
//         <>
//             <section style={{ boxShadow: "0 6px 6px -6px #777" }}>
//                 <div class="navi" >
//                     <input type="checkbox" id="nav-check" />
//                     <div class="nav-header">
//                         <div class="nav-title">
//                             <Link to={`/${params.id.toLowerCase()}`} > <img src="/images/youvati_logo.webp" alt="" style={{ height: "27px", marginLeft: "2rem" }} /></Link>
//                         </div>
//                     </div>


//                 </div>
//             </section>
//             {isLoading ? <div>
//                 <img src="images/loader.gif" alt="" class="" style={{ display: "block", marginLeft: "auto", marginRight: "auto", width: "40%" }} />
//             </div> :
//                 <section class="section bg-default bg-gray-100 mb-5">
//                     <div class="container-fluid">

//                         <div class="container pt-5 certificateviewH" >
//                             <div class="row">
//                                 {personalData.certificates.map((e) => (
//                                     <div class="col">
//                                         <div class=" pb-2" style={{ height: "9rem", width: "9rem", marginBottom: "2rem" }}>
//                                             <img src={e} alt="" class="img-thumbnail" width="200" height="200" />
//                                         </div>
//                                     </div>
//                                 ))
//                                 }



//                             </div>
//                         </div>
//                         <div class="row">
//                             <div class="col-md-1"></div>
//                             <div class="col-md-2 p-4 certificateviewV" style={{ backgroundColor: "" }}>
//                                 <ul class="">
//                                     {personalData.certificates.map((e) => (
//                                         <li>
//                                             <img src={e} onClick={() => selectedImage(e)} alt="" class="img-thumbnail" width="204" height="136" />
//                                         </li>
//                                         //  <br />
//                                     ))
//                                     }




//                                 </ul>
//                             </div>
//                             <div class="col-md-8 p-4" style={{ backgroundColor: "" }}>
//                                 <img src={img === "" ? personalData.certificates[0] : img} class="img-fluid" alt="Responsive image" width="780" />
//                             </div>
//                         </div>
//                     </div>
//                 </section>
//             }

//             <Footer />

//         </>
//     );
// }

// export default Certificates;




